import React from 'react';
import Header from '../../../../Header';
import Footer from '../../../../Footer';
import RentalYieldCalculator from './RentalYieldCalculator';

const RentalYieldInfo = () => {
  return (
    <div className="bg-[#FFFFFF] rounded-lg shadow-lg p-6">
      <h2 className="text-[#1C52A0] text-2xl font-semibold mb-4">Rental Yield Calculator</h2>
      <p className="mb-4 text-[#0D0D0D]">The Rental Yield Calculator helps property investors and landlords determine the potential return on investment for rental properties. It calculates the annual rental yield based on property value and rental income, providing valuable insights for investment decisions.</p>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Key Components</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Property Value</li>
        <li>Monthly Rent</li>
        <li>Annual Yield</li>
        <li>Gross Rental Yield</li>
        <li>Net Rental Yield</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">How It Works</h3>
      <p className="mb-4 text-[#0D0D0D]">The calculator uses the following formula to determine rental yield:</p>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Gross Rental Yield = (Annual Rent / Property Value) × 100%</li>
        <li>Net Rental Yield = (Annual Rent - Expenses) / Property Value × 100%</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Benefits</h3>
      <ul className="list-disc pl-6 mb-4 text-[#0D0D0D]">
        <li>Evaluate investment potential</li>
        <li>Compare property investments</li>
        <li>Assess rental market conditions</li>
        <li>Plan property investments</li>
        <li>Make informed investment decisions</li>
      </ul>

      <h3 className="text-[#1C52A0] text-xl font-semibold mb-3">Using the Calculator</h3>
      <p className="mb-4 text-[#0D0D0D]">Enter your property value and monthly rent to calculate the gross rental yield. For a more accurate net yield, include estimated expenses such as maintenance, property taxes, and insurance. The calculator will provide you with valuable insights to help you make informed investment decisions.</p>
    </div>
  );
};

const RentalYield = () => {
  return (
    <>
      <Header/>
      <main className="overflow-x-hidden">
        <div className="relative z-20">
          <RentalYieldCalculator/>
        </div>
        <RentalYieldInfo />
      </main>
      <div className="relative z-20">
        <Footer />
      </div>
    </>
  );
};

export default RentalYield;